<template>
	<el-submenu class="lmf-submenu" v-if="menuOne.meunColl" :index="index+''" :title="!isCollapse?menuOne.menuName:''">
		<template slot="title" >
      <div style="height:36px;line-height:36px;">
        <img v-if="menuOne.menuImage" :src="GLOBAL.getFileServeUrl()+menuOne.menuImage" class="zdy_menu_img zdy_menu_img_filter"/>
        <i v-else class="el-icon-menu" ></i>
        <span slot="title">{{menuOne.menuName}}</span>
      </div>
		</template>
		<!-- 第二层子元素 -->
		<el-menu-item-group v-for="(childTwoMenu,twoIndex) in menuOne.meunColl" :key="childTwoMenu.menuId">
			<el-menu-tree :menuOne="childTwoMenu" :floor="floor+'_'+index" :index="index+'_'+twoIndex" ></el-menu-tree>
		</el-menu-item-group>
   </el-submenu>
	
	<el-menu-item v-else style="height:36px;line-height:36px;" :index="index+''" :title="!isCollapse?menuOne.menuName:''">
      <img v-if="menuOne.menuImage" :src="GLOBAL.getFileServeUrl()+menuOne.menuImage" class="zdy_menu_img zdy_menu_img_filter"/>
			<i v-else class="el-icon-document"></i>
			<span slot="title">{{menuOne.menuName}}</span>
	</el-menu-item>
</template>

<script>
export default {
  name: 'el-menu-tree',
  props: {
    menuOne: Object,
    index:String,
    floor:String,
	isCollapse:Boolean
  },
  data() {
    return {
      
    };
  },
  created() {
    
  },
  mounted() {
    
  },
  watch:{
  },
  computed:{
  },
  components: {
  },
  methods: {
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.zdy_menu_img{width:20px;height:20px;margin-left:6px;margin-right:8px;}
.black .zdy_menu_img_filter{filter: invert(1);}
.blue .zdy_menu_img_filter{filter: invert(1);}
.white .zdy_menu_img_filter{filter: brightness(0.5);}
</style>
<style>
.lmf-submenu .el-menu-item, .el-submenu__title{height:36px !important;line-height:36px !important;}
.black .lmf-submenu .el-submenu__icon-arrow{color: #fff !important;font-weight: bold !important;}
.blue .lmf-submenu .el-submenu__icon-arrow{color: #fff !important;font-weight: bold !important;}
.white .lmf-submenu .el-submenu__icon-arrow{color: rgb(17, 22, 56) !important;font-weight: bold !important;}
/* padding:0 3px !important; */
</style>
